<template>
  <div id="app" :style="{'minWidth': setToWindowWidth}">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    setToWindowWidth() {
      return window.screen.width - 20 + "px";
    },
  },
};
</script>

<style>
* {
  margin: 0px;
  padding: 0px;
}
#app {
  font-family: "MicrosoftYaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  /* min-width: 1660px; */
}
/* MicrosoftYaHei */
/* Avenir */
/* Helvetica */
</style>




// WEBPACK FOOTER //
// src/App.vue